import * as React from 'react';
import { getToken } from '@workiva/unify-tokens';

import fileListItemClasses from 'src/components/FileListItem/fileListItemClasses';
import type {
  FileModel,
  FileLike,
} from 'src/components/FileUploader/fileModel';
import {
  ListItemText,
  type ListItemTextProps,
} from 'src/components/ListItemText';
import { mergeSlotProps } from '@mui/material';

export type FileListItemTextOwnProps = {
  fileName: FileLike['name'];
  errors: NonNullable<FileModel['errors']>;
};

export type FileListItemTextProps = ListItemTextProps &
  FileListItemTextOwnProps;

export function FileListItemText(
  props: FileListItemTextProps
): React.ReactElement | null {
  const { errors, fileName, slotProps, ...rest } = props;

  return (
    <ListItemText
      {...rest}
      slotProps={{
        ...slotProps,
        primary: mergeSlotProps(slotProps?.primary, {
          variant: 'h6',
          noWrap: true,
          className: fileListItemClasses.fileName,
        }),
        secondary: mergeSlotProps(slotProps?.secondary, {
          variant: 'caption',
          color: getToken('Core/Text/text-error'),
          className: fileListItemClasses.fileErrorMessage,
        }),
      }}
      primary={fileName}
      secondary={
        errors.length === 0
          ? undefined
          : errors.map((err, index) => (
              <div key={`error-message-${index}`}>{err.message}</div>
            ))
      }
    />
  );
}

export default FileListItemText;
